import { common } from '../config/configuration';
import BaseApi from './BaseApi';
import { UpdateContactAddressRequest } from './request_type/UpdateContactAddressRequest';
import { UpdateTrackingAddressRequest } from './request_type/UpdateTrackingAddressRequest';
import { UserVerifyPostcodeRequest } from './request_type/UserVerifyPostcodeRequest';
import { verifyAddressRequest } from './request_type/VerifyAddressRequest';

export default class UpdateTrackingAddressApi extends BaseApi {
    constructor() {
        super();
        this.BASE_URL = common.apiUrl;
    }

  public async UserVerifyFromPostCode(payload: UserVerifyPostcodeRequest): Promise<any> {
        let data: any = await this.postOpenApi('userVerifyFromPostCode', payload);
        return data;
      }
    public async UpdateContactAddressAction(
        payload: UpdateContactAddressRequest,
    ): Promise<any> {
        let data: any = await this.postOpenApi('updateContactAddress', payload);
        // if (data.actions) {
        //   data.data = data.actions;
        // }
        return data;

    }
    public async UpdateTrackingAddressAction(payload: UpdateTrackingAddressRequest): Promise<any> {
        let data: any = await this.postOpenApi('updateAddressFromTracking', payload);
        return data;
      }
      public async UpdateVerifyAddress(payload: verifyAddressRequest): Promise<any> {
        let data: any = await this.postOpenApi('verifyAddress', payload);
        return data;
      }
}
